import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ReportType } from "../../../../../api/types/svTypes";

export interface SupportedReportTypesContextType {
  supportedReportTypes: ReportType[];
}

export const SupportedReportTypesContext = createContext<SupportedReportTypesContextType>({
  supportedReportTypes: [],
});

export const useSupportedReportTypesContext = () => {
  const context = use(SupportedReportTypesContext);
  return defined(context);
};
